function SectionHeading({ kicker, title, description, center = true, light = false }) {
  return (
    <div className={center ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      {kicker ? (
        <p
          className={`mb-4 text-xs font-semibold uppercase tracking-[0.22em] ${
            light ? "text-sky-glow/90" : "text-royal-blue"
          }`}
        >
          {kicker}
        </p>
      ) : null}
      <h2 className={`text-2xl leading-tight sm:text-3xl md:text-5xl ${light ? "text-soft-white" : ""}`}>
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-4 text-sm leading-relaxed sm:text-base md:text-lg ${
            light ? "text-sky-glow/80" : "text-slate-text/80"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}

export default SectionHeading;
